export const routeToName: {
  [key: string]: string;
} = {
  'reports/datatable/view': 'Reports (Datatable)',
  'reports/datatable': 'Reports (Datatable)',
  'reports/chart/view': 'Reports (Chart)',
  'reports/chart': 'Reports (Chart)',
  'reports/map/view': 'Reports (Map)',
  'reports/map': 'Reports (Map)',
  'reports/gantt': 'Reports (Gantt)',
  'reports/gantt/view': 'Reports (Gantt)',
  'reports/summary/view': 'Reports (Summary)',
  'reports/summary': 'Reports (Summary)',
  'reports/calendar/view': 'Reports (Calendar)',
  'reports/calendar': 'Reports (Calendar)',
  'forms/web': 'Forms (Web)',
  'forms/mobile': 'Forms (Mobile)',
  'forms/pdf': 'Forms (PDF)',
  'forms/word': 'Forms (Word)',
  'notifications/notification': 'Notifications',
  'notifications/subscription': 'Subscriptions',
  'notifications/webhook': 'Webhooks',
  'forms/action/add': 'Forms (Add)',
  'field/summary': 'Fields (Summary)',
  'settings/user-interface/dashboard/view': 'Dashboards',
  'settings/user-interface/pages/view': 'View Page',
  'settings/user-interface/pages/edit': 'Edit Page',
  'settings/user-interface/pages/create': 'Create Page',
  summaryFieldId: 'Summary field',
};

export const routeToAppRoute: {
  [key: string]: Array<string>;
} = {
  'reports/datatable/view': ['reports'],
  'reports/chart/view': ['reports'],
  'reports/summary/view': ['reports'],
  'reports/calendar/view': ['reports'],
  'reports/map/view': ['reports'],
  'reports/gantt/view': ['reports'],
  'reports/gantt': ['reports'],
  'reports/datatable': ['reports'],
  'reports/chart': ['reports'],
  'reports/summary': ['reports'],
  'reports/calendar': ['reports'],
  'field/summary': ['fields'],
  'forms/web': ['forms'],
  'forms/mobile': ['forms'],
  'forms/pdf': ['forms'],
  'forms/word': ['forms'],
  'settings/user-interface/dashboard/view': [],
  'settings/user-interface/pages/view': [],
  'notifications/notification': ['notifications'],
  'notifications/subscription': ['notifications'],
  'notifications/webhook': ['notifications'],
  summaryFieldId: [],
};
